import { z } from "zod";

/** CRPPC — Recycled Content / Packaging Declaration. Code-verified field set
 * (Resin Type / Sub-Commodity / % Post-Consumer Material) — NOT conflict
 * minerals (3TG), correcting the legacy mislabel. */
export const RESIN_TYPES = ["PET", "HDPE", "PVC", "LDPE", "PP", "PS"] as const;

export const crppcDeclarationCreateSchema = z.object({
  vendorId: z.number().int(),
  materialNumber: z.string().min(1),
  resinType: z.enum(RESIN_TYPES),
  subCommodity: z.string().min(1),
  postConsumerPct: z.number().min(0).max(100),
  capabilityIncreasePcm: z.boolean().optional(),
  mitigationPlan: z.string().optional(),
});
export type CrppcDeclarationCreateInput = z.infer<typeof crppcDeclarationCreateSchema>;
